<template>
  <div id="live-sessions">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="el-icon-video-camera-solid"
              type="warning"
              size="small"
              round
              @click="
                archiveModal = true;
                sessionID = null;
              "
            >
              {{ $t("liveSessions.broadcastRecordings") }}
            </el-button>
          </li>
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('liveSessions.searchPlaceholder')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.livesessions.filter.searchTerm != '' && $store.state.livesessions.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button icon="fas fa-plus" type="primary" size="small" round @click="addLiveDialog = true">{{ $t("liveSessions.addSession") }}</el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("liveSessions.filter") }}</h5>
                <span>{{ $t("liveSessions.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.livesessions.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.livesessions.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.livesessions.title") }}</h5>
              <span v-if="$store.state.livesessions.items.length > 0" v-html="$t('totalContent', [$store.state.livesessions.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-create-and-manage-live-sessions')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.livesessions.items.length > 0">
            <div class="custom-grid-table-header live-sessions-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <span>{{ $t("liveSessions.liveSession") }}</span>
              <span>{{ $t("liveSessions.startEnd") }}</span>
              <span>{{ $t("liveSessions.duration") }}</span>
              <!-- <el-tooltip effect="dark" placement="top-start">
                <div class="tooltip-wrapper" slot="content">{{ $t("liveSessions.speakersForBroadcast") }}</div>
                <span>
                  {{ $t("liveSessions.speaker") }}
                  <i class="el-icon-info"></i>
                </span>
              </el-tooltip> -->
              <span></span>
            </div>

            <draggable :list="$store.state.livesessions.items" class="live-session-container" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
              <div class="item" v-for="item in $store.state.livesessions.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="content-inner">
                  <div>
                    <i class="el-icon-s-grid burger"></i>
                  </div>

                  <div class="live-session-item-img-title">
                    <div class="img" :style="'background-image:url(' + $imageus + item.image + '?width=112&height=50&mode=cover)'"></div>
                    <div class="live-session-item-title">
                      <div class="watcher-info" v-if="item.isActive">
                        <div class="watcher-container">
                          <div class="watcher-badge" :class="item.isLive ? 'islive' : 'iswaiting'">
                            <i class="fa" :class="item.isLive ? 'fa-video' : 'fa-clock'"></i>
                            {{ item.isLive ? $t("liveSessions.live") : $t("liveSessions.waiting") }} ({{ item.watcherCount }})
                          </div>
                        </div>
                        <!-- <i class="fab fa-youtube youtube" :class="{ active: item.isLive }"></i> -->
                      </div>
                      {{ item.title }}
                    </div>
                  </div>

                  <div class="live-session-date">
                    <div class="start">
                      <i class="fas fa-calendar"></i>
                      {{ $moment(item.startDate).format("Do MMM") + ", " + item.startTime }}
                    </div>
                    <div class="end">
                      <i class="el-icon-right"></i>
                      {{ $moment(item.endDate).format("Do MMM") + ", " + item.endTime }}
                    </div>
                  </div>
                  <div class="item-color-container">
                    <i class="el-icon-watch"></i>
                    {{ $dateDisplayer(item.startDate, item.endDate) }}
                  </div>

                  <!-- <div class="item-color-container pointer" @click="item.publishers.length > 0 ? (item.show = !item.show) : (item.show = false)" v-if="item.sessionType == 0">
                    <i class="el-icon-user-solid"></i>
                    {{ item.publishers.length }}
                  </div>
                  <div v-else></div> -->

                  <div class="action-btns">
                    <el-tooltip effect="dark" :content="$t('watchBroadcast')" placement="top">
                      <el-button type="warning" :disabled="!item.isActive || !item.isLive" icon="el-icon-video-play" size="mini" @click="watchRTMPVideo(item.id)" circle v-if="item.sessionType == 1"></el-button>
                    </el-tooltip>
                    
                    <el-tooltip effect="dark" :content="$t('liveSessions.broadcastRecordings')" placement="top">
                      <el-button icon="el-icon-video-camera-solid" type="warning" size="mini" circle @click="openArchiveModal(item.id)" v-if="item.sessionType == 1"></el-button>
                    </el-tooltip>

                    <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                      <el-button
                        icon="fas fa-pen"
                        circle
                        size="mini"
                        type="primary"
                        @click="
                          updateId = item.id;
                          editLiveDialog = true;
                        "
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                      <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteItem-' + item.id" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>

                <transition name="el-zoom-in-top" mode="out-in">
                  <div class="info" v-if="item.show">
                    <div class="participant-card-mini" v-for="speaker in item.publishers" :key="speaker.id">
                      <div class="participant-card-mini-left" v-if="getTag(speaker.participantID)">
                        <el-tooltip effect="dark" :content="getTag(speaker.participantID).title" placement="top" v-if="$store.state.tags.items.length > 0">
                          <span :style="{ 'background-color': getTag(speaker.participantID).color }"></span>
                        </el-tooltip>
                      </div>

                      <div class="participant-card-mini-right">
                        <div class="participant-card-mini-num">#{{ $store.state.livesessions.participants.find(x => x.id == speaker.participantID).participantNO }}</div>
                        <div class="participant-card-mini-title">{{ $store.state.livesessions.participants.find(x => x.id == speaker.participantID).title }}</div>
                        <div class="participant-card-mini-container">
                          <span>
                            <i class="el-icon-user-solid"></i>
                            {{ getEnumsDisplay("LiveStreamParticipantType", speaker.type) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-sessions-lottie'" :title="$t('event.menu.livesessions.title')" @btnAdd="addLiveDialog = true" @btnRefresh="refreshList()" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('event.tags.editSession')" width="80%">
      <LiveSessionAddUpdate :key="modalVisible" @deleteMe="deleteItem" @closeMe="modalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="vimeoModalVisible" :title="$t('event.tags.addVimeo')" width="80%">
      <VimeoLiveSessionAddUpdate :key="vimeoModalVisible" @deleteMe="deleteItem" @closeMe="vimeoModalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="sceneModal" :title="$t('event.components.liveEventExp.nav.scenes.title')" width="80%">
      <Scenes @deleteMe="deleteItem" @closeMe="modalVisible = false" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="watchModal" :title="$t('watchBroadcast')" width="80%" @close="closeWatch">
      <video preload="none" id="videoRoomPlayer" controls crossorigin style="width:100%; height:100%"></video>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="archiveModal" :title="$t('event.table.broadcastRecords')" class="large">
      <ArchiveModal v-if="archiveModal" @closeDialog="archiveModal = false" :sessionId="sessionID" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('archiveSess')" :visible.sync="watchDialogVisible" class="large" center append-to-body destroy-on-close>
      <video :src="url" autoplay controls style="width: 100%; height: 400px"></video>
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer;" @click="download">
        <i class="el-icon-download" style="font-size: 50px"></i>
        <h3 style="font-size: 20px; margin-top: 10px; font-weight: 100; text-align: center;">
          {{ this.$t("downloadArch") }}
        </h3>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('liveSessions.liveSessionManagament')" :visible.sync="editLiveDialog" class="xlarge" center modal-append-to-body destroy-on-close>
      <EditLiveStream @closeDialog="editLiveDialog = false" :id="updateId" @deleteMe="deleteItem" v-if="editLiveDialog" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="$t('liveSessions.createLiveSession')" :visible.sync="addLiveDialog" v-if="addLiveDialog" class="xlarge" center modal-append-to-body destroy-on-close>
      <CreateLiveStream @closeDialog="addLiveDialog = false" />
    </el-dialog>
  </div>
</template>

<script>
import ArchiveModal from "../../components/live-stream/archiveModal.vue";
import draggable from "vuedraggable";
import EditLiveStream from "../../components/live-stream/editLiveStream.vue";
import CreateLiveStream from "../../components/live-stream/createLiveStream.vue";
import LiveSessionAddUpdate from "../../components/LiveSessionAddUpdate";
import VimeoLiveSessionAddUpdate from "../../components/VimeoLiveSessionAddUpdate";
import axios from "axios";
import moment from "moment";
import PageCountInfo from "../../components/PageCountInfo";
import Scenes from "../../components/Scenes";
import { saveAs } from "file-saver";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.liveSessions")
    };
  },
  components: {
    ArchiveModal,
    LiveSessionAddUpdate,
    PageCountInfo,
    Scenes,
    VimeoLiveSessionAddUpdate,
    CreateLiveStream,
    EditLiveStream,
    draggable
  },
  name: "LiveSessions",
  data() {
    return {
      loading: false,
      listShort: false,
      updateId: null,
      editLiveDialog: false,
      moment,
      addLiveDialog: false,
      watchModal: false,
      flvPlayer: null,
      modalVisible: false,
      vimeoModalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
      sceneModal: false,
      archiveModal: false,
      sessionID: null,
      fullscreenevent: false,
      options: {
        debug: false,
        clickToPlay: true,
        settings: ["quality"]
      },
      url: null,
      watchUrl: null,
      watchDialogVisible: false,
      archiveID: null,
      vimeoImg: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Vimeo_Logo.svg/1280px-Vimeo_Logo.svg.png"
    };
  },
  methods: {
    goUpgrade() {
      window.open(`/organisation/${this.$store.state.event.event.organizationID}/billing`, "_self");
    },
    openArchiveModal(id) {
      this.sessionID = id;
      this.archiveModal = true;
    },
    getTag(id) {
      var speaker = this.$store.state.livesessions.participants.find(x => x.id == id);
      var tag = this.$store.state.tags.items.find(x => x.id == speaker.tagID);
      return tag;
    },

    deleteArchive(id) {
      axios.post("livestream/deletearchive", { id: id }).then(res => {
        if (res.data.alert.hasError == false) {
          this.$store.dispatch("getLiveSessions");
          this.$message.success(res.data.alert.message);
        } else {
          this.$message.error(res.data.alert.message);
        }
      });
    },

    async changeSort() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      this.listShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.livesessions.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveLiveSessionOrders", payload);
        await this.$store.dispatch("getLiveSessions");
        this.loading = false;
      }, 500);
    },

    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getLiveSessions");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    closeWatch() {
      this.flvPlayer.destroy();
    },
    async watchRTMPVideo(sessionId) {
      var res = await axios.post("livestream/gethash", { id: sessionId });
      if (res.data.alert.hasError == false) {
        this.watchUrl = res.data.data;
        this.watchModal = true;
      } else {
        this.$message.error(res.data.alert.message);
      }
      this.$nextTick(() => {
        var video = document.querySelector("#videoRoomPlayer");
        console.log(video, "video");
        if (flvjs.isSupported()) {
          this.flvPlayer = flvjs.createPlayer(
            {
              isLive: true,
              type: "flv",
              url: `wss://rtmp2.holacon.com/live/${sessionId}.flv?sign=${this.watchUrl}`
            },
            {
              enableWorker: false, // Do not enable detach threads
              enableStashBuffer: false, // close IO Hide buffer
              reuseRedirectedURL: true, // reusing 301/302 Redirect url, For subsequent requests , Such as search 、 Reconnect, etc .
              autoCleanupSourceBuffer: true // Automatically clear cache
            }
          );
          this.flvPlayer.attachMediaElement(video);
          this.flvPlayer.load();
          this.flvPlayer.play();
          console.log("Video has started FLV WS Player");
        }

        const player = new Plyr(video, this.options);

        // Expose player and dash so they can be used from the console
        window.player = player;
        //window.dash = dash;

        //DOCUMENTATION : https://github.com/sampotts/plyr
        player.on("enterfullscreen", event => {
          this.fullscreenevent = true;
        });

        player.on("exitfullscreen", event => {
          this.fullscreenevent = false;
        });
      });
    },
    download() {
      window.open(this.url, "_blank");
    },
    async unlock(item, action) {
      this.archiveID = item.id;
      if (item.unlocked == false) {
        var confirmed = await this.$confirm(
          /* "Bu arşivi indirebilmek için hesabınızdan tek seferlik " +
            item.credit +
            " kredi düşülecektir. Onaylıyor musunuz?", */
          this.$t("options.confirmation", item.credit, { n: item.credit }),
          this.$t("message.warn"),
          {
            confirmButtonText: this.$t("event.variables.yes"),
            cancelButtonText: this.$t("event.variables.no"),
            type: "warning"
          }
        );

        if (confirmed == "confirm") {
          axios.post("livestream/unlock", { id: item.id }).then(res => {
            if (res.data.alert.hasError) {
              this.$message.error(res.data.alert.message);
            } else {
              var url = res.data.data;
              this.url = url;
              this.watchDialogVisible = true;
            }
          });
        }
      } else {
        axios.post("livestream/unlock", { id: item.id }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            var url = res.data.data;
            this.url = url;
            this.watchDialogVisible = true;
          }
        });
      }
    },
    initUpdate(row) {
      var speakers = this.$store.state.livesessions.participants.filter(k => row.publishers.some(x => x.participantID == k.id));

      speakers.map((item, index) => {
        speakers[index].isActive = row.publishers.find(k => k.participantID == item.id).isActive;
      });

      this.updateForm = JSON.parse(JSON.stringify({ ...row, publishers: speakers }));
      this.modalVisible = true;
    },
    itemUpdated(item) {
      this.$store.dispatch("getLiveSessions");
    },
    itemAdded(item) {
      this.$store.dispatch("getLiveSessions");
    },
    handleSizeChange(take) {
      this.$store.commit("setVenueTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setVenuePage", page);
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteLiveSession", id);
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleVenue", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedVenues", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getLiveSessions");
      this.$store.dispatch("listScenes");
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.livesessions.filter.page - 1) * this.$store.state.livesessions.filter.take;
    },
    take() {
      return this.skip + this.$store.state.livesessions.items.length;
    }
  },
  watch: {
    "$store.state.livesessions.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getLiveSessions");
      }, 500);
    },
    watchDialogVisible: function() {
      if (this.watchDialogVisible == false) {
        document.getElementsByTagName("video")[0].pause();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.watcher-info {
  .youtube {
    font-size: 30px;
    color: black;
    &.active {
      color: #f44336;
    }
  }
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  .watcher-container {
    .watcher-badge {
      width: max-content;
      font-weight: 500;
      padding: 3px 12px;
      border-radius: 20px;
      color: white;

      &.islive {
        background: #f22f2f;
      }

      &.iswaiting {
        background: #ff7511;
      }
    }
  }
}
.live-sessions-grid-template {
  grid-template-columns: 36px 1fr 340px 120px 105px;
}
.item-color-container {
  padding: 5px 10px;
  width: max-content;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  color: #505763;
  font-size: 13px;

  i {
    margin-right: 0.25rem;
    font-size: 14px;
    color: #292f3b;
    font-weight: 600;
  }
  &.pointer {
    cursor: pointer;
  }
}
.live-session-container {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    & > .content-inner {
      .action-btns {
        display: flex;
        flex-direction: row;
        gap: 0.3rem;
        .el-button {
          margin: 0;
        }
      }
      .live-session-date {
        display: flex;
        flex-direction: row;
        gap: 0.35rem;

        & > div {
          display: flex;
          flex-direction: row;
          gap: 0.35rem;
          align-items: center;
        }
        .start,
        .end {
          font-size: 13px;
          color: #505763;
          font-weight: 500;

          i {
            font-weight: bold;
            font-size: 14px;
            color: #292f3b;
            font-weight: 600;
          }
        }
      }

      .live-session-item-img-title {
        display: flex;
        gap: 1rem;
        font-weight: 500;
        align-items: center;
        .live-session-item-title {
          font-weight: bold;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }

        & > .img {
          border-radius: 8px;
          width: 112px;
          height: 50px;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
        }
      }

      display: grid;
      grid-template-columns: 36px 1fr 340px 120px 105px;
      gap: 0.5rem;
      padding: 10px;
      align-items: center;
      border-radius: 8px;
      transition: all 0.5s;
      & > div:last-child {
        justify-self: flex-end;
      }
    }
    .info {
      transition: all 0.5s ease-in-out;
      display: grid;
      padding: 10px;
      gap: 1rem;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }

    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
</style>
.
<style lang="less">
.modal-base-small {
  min-width: 800px;
}
.modal-base-mini {
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/LiveSessions.vue